import { render, staticRenderFns, recyclableRender, components } from "./list.vue?vue&type=template&id=88484d7c&scoped=true&"
var renderjs
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=88484d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88484d7c",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uce-pay-article/pages/list.vue"
export default component.exports